import { createBrowserRouter, Navigate } from 'react-router-dom';

import { ErrorPage } from '@/components/feedback/state-pages';
import { AsistentePage } from '@/features/asistente/pages/asistente-page';
import { AutoservicioLayout } from '@/features/autoservicio/pages/autoservicio-layout';
import {
  AutoservicioColaPage,
  AutoservicioOperacionesPage,
  AutoservicioResumenPage,
  AutoservicioTurnosPage,
} from '@/features/autoservicio/pages/autoservicio-pages';
import { LoginPage } from '@/features/auth/pages/login-page';
import { BonusAcumularPage } from '@/features/bonus/pages/bonus-acumular-page';
import { BonusBalancePage } from '@/features/bonus/pages/bonus-balance-page';
import { BonusCanjePage } from '@/features/bonus/pages/bonus-canje-page';
import { BonusTransaccionesPage } from '@/features/bonus/pages/bonus-transacciones-page';
import { CalibracionCodigosPage } from '@/features/calibracion/pages/calibracion-codigos-page';
import { CalibracionDetallesPage } from '@/features/calibracion/pages/calibracion-detalles-page';
import { CalibracionReportePage } from '@/features/calibracion/pages/calibracion-reporte-page';
import { BancosPage } from '@/features/configuracion/pages/bancos-page';
import { ConfiguracionPage } from '@/features/configuracion/pages/configuracion-page';
import { ComprobantesPage as ComprobantesServiciosPage } from '@/features/configuracion/pages/comprobantes-page';
import { ServiciosPage } from '@/features/configuracion/pages/servicios-page';
import { TurnoPage } from '@/features/turno/pages/turno-page';
import { TurnoCerrarPage } from '@/features/turno/pages/turno-cerrar-page';
import { TurnoCreditosPage } from '@/features/turno/pages/turno-creditos-page';
import { TurnoComprobantePage } from '@/features/turno/pages/turno-comprobante-page';
import { TurnoDocumentosPage } from '@/features/turno/pages/turno-documentos-page';
import { TurnoNotasPage } from '@/features/turno/pages/turno-notas-page';
import { SoloOperadorTurno } from '@/features/turno/components/solo-operador-turno';
import { CuentasBancariasPage } from '@/features/configuracion/pages/cuentas-bancarias-page';
import { EmpresaPage } from '@/features/configuracion/pages/empresa-page';
import { LogsPage } from '@/features/configuracion/pages/logs-page';
import { LadosPage } from '@/features/configuracion/pages/lados-page';
import { ManguerasPage } from '@/features/configuracion/pages/mangueras-page';
import { MaquinasPage } from '@/features/configuracion/pages/maquinas-page';
import { MetodosPagoDetraccionPage } from '@/features/configuracion/pages/metodos-pago-detraccion-page';
import { MetodosPagoPage } from '@/features/configuracion/pages/metodos-pago-page';
import { ModulosPage } from '@/features/configuracion/pages/modulos-page';
import { MonedasPage } from '@/features/configuracion/pages/monedas-page';
import { NfcPage } from '@/features/configuracion/pages/nfc-page';
import { OperadoresPage } from '@/features/configuracion/pages/operadores-page';
import { PagosCpePage } from '@/features/configuracion/pages/pagos-cpe-page';
import { PlanesPage } from '@/features/configuracion/pages/planes-page';
import { RicAutomationPage } from '@/features/configuracion/pages/ric-automation-page';
import { SeriesDocumentoPage } from '@/features/configuracion/pages/series-documento-page';
import { TarjetasPage } from '@/features/configuracion/pages/tarjetas-page';
import { TiposDetraccionPage } from '@/features/configuracion/pages/tipos-detraccion-page';
import { TiposDocumentoPage } from '@/features/configuracion/pages/tipos-documento-page';
import { TurnosCatalogoPage } from '@/features/configuracion/pages/turnos-catalogo-page';
import { DashboardPage } from '@/features/dashboard/pages/dashboard-page';
import { FaqPage } from '@/features/faq/pages/faq-page';
import { ActivosPage } from '@/features/mantenimiento/pages/activos-page';
import { AsignacionesPage } from '@/features/logistica/pages/asignaciones-page';
import { CanjesCardplusPage } from '@/features/logistica/pages/canjes-page';
import { DocumentosPage } from '@/features/logistica/pages/documentos-page';
import { NotasVentaPage } from '@/features/logistica/pages/notas-venta-page';
import { VentasMarketPage } from '@/features/logistica/pages/ventas-market-page';
import { VentasCreditoPage } from '@/features/logistica/pages/ventas-credito-page';
import { PagosAdelantadosPage } from '@/features/logistica/pages/pagos-adelantados-page';
import { PagosAdelantadosDocumentosPage } from '@/features/logistica/pages/pagos-adelantados-documentos-page';
import { BovedasPage } from '@/features/logistica/pages/bovedas-page';
import { GastosPage } from '@/features/logistica/pages/gastos-page';
import { IngresosExtrasPage } from '@/features/logistica/pages/ingresos-extras-page';
import { NotasCreditoPage } from '@/features/logistica/pages/notas-credito-page';
import { SaldosAutoservicioPage } from '@/features/logistica/pages/saldos-autoservicio-page';
import { InventarioEntradasPage } from '@/features/gestion/pages/inventario-entradas-page';
import { InventarioListadoPage } from '@/features/gestion/pages/inventario-listado-page';
import { InventarioSalidasPage } from '@/features/gestion/pages/inventario-salidas-page';
import { ClientesPage } from '@/features/gestion/pages/clientes-page';
import { ClientesSaldosPage } from '@/features/gestion/pages/clientes-saldos-page';
import { MensajesClientesPage } from '@/features/gestion/pages/mensajes-clientes-page';
import { DiferenciaDiariaPage } from '@/features/gestion/pages/diferencia-diaria-page';
import { ProductosPage } from '@/features/gestion/pages/productos-page';
import { AdministracionPage } from '@/features/gestion/pages/administracion-page';
import { ClientesAppPage } from '@/features/gestion/pages/clientes-app-page';
import { CardplusPage } from '@/features/gestion/pages/cardplus-page';
import { CanjesNotasPage } from '@/features/gestion/pages/canjes-notas-page';
import { BoletajeMasivoPage } from '@/features/gestion/pages/boletaje-masivo-page';
import { GeneradorMasivoPage } from '@/features/gestion/pages/generador-masivo-page';
import { ComprobantesPage } from '@/features/gestion/pages/comprobantes-page';
import { ComprobanteCrearPage } from '@/features/gestion/pages/comprobante-crear-page';
import { ConsumoClientePage } from '@/features/gestion/pages/consumo-cliente-page';
import { CotizacionFormPage } from '@/features/gestion/pages/cotizacion-form-page';
import { CotizacionListadoPage } from '@/features/gestion/pages/cotizacion-listado-page';
import { HermesPage } from '@/features/gestion/pages/hermes-page';
import { ComprasPage } from '@/features/gestion/pages/compras-page';
import { ProveedoresPage } from '@/features/gestion/pages/proveedores-page';
import { CreditosPage } from '@/features/gestion/pages/creditos-page';
import { FletesPage } from '@/features/gestion/pages/fletes-page';
import { PricingConfiguracionPage } from '@/features/pricing/pages/pricing-configuracion-page';
import { PricingDashboardPage } from '@/features/pricing/pages/pricing-dashboard-page';
import { PricingEstadisticasPage } from '@/features/pricing/pages/pricing-estadisticas-page';
import { PricingPreciosPage } from '@/features/pricing/pages/pricing-precios-page';
import { PricingScrapingPage } from '@/features/pricing/pages/pricing-scraping-page';
import { CategoriasPage } from '@/features/mantenimiento/pages/categorias-page';
import { MantenimientoDashboardPage } from '@/features/mantenimiento/pages/dashboard-page';
import { ReportesMantenimientoPage } from '@/features/mantenimiento/pages/reportes-page';
import { ReportesPage } from '@/features/reportes/pages/reportes-page';
import { HistorialPreciosPage } from '@/features/reportes/pages/historial-precios-page';
import { ReporteDocumentosPage } from '@/features/reportes/pages/documentos-page';
import { ReporteGastosPage } from '@/features/reportes/pages/gastos-page';
import { ReporteVentasDescuentosPage } from '@/features/reportes/pages/ventas-descuentos-page';
import { ReporteBitacoraIzipayPage } from '@/features/reportes/pages/bitacora-izipay-page';
import { ReporteConsumoInternoPage } from '@/features/reportes/pages/consumo-interno-page';
import { ReporteFacturasPendientesPage } from '@/features/reportes/pages/facturas-pendientes-page';
import { ReporteSerieFechaProductoPage } from '@/features/reportes/pages/serie-fecha-producto-page';
import { ReporteKardexPage } from '@/features/reportes/pages/kardex-page';
import { ReporteCreditosClientePage } from '@/features/reportes/pages/creditos-cliente-page';
import { ReporteFaltantesPersonalPage } from '@/features/reportes/pages/faltantes-personal-page';
import { ReporteDescuentosActivosPage } from '@/features/reportes/pages/descuentos-activos-page';
import { ReporteProductividadTurnosPage } from '@/features/reportes/pages/productividad-turnos-page';
import { ReporteMovimientosCuentaPage } from '@/features/reportes/pages/movimientos-cuenta-page';
import { ReporteNubecontPage } from '@/features/reportes/pages/nubecont-page';
import { ReportePlacasClientesPage } from '@/features/reportes/pages/placas-clientes-page';
import { ReporteIngresoBovedaPage } from '@/features/reportes/pages/ingreso-boveda-page';
import { ReporteVentaProductosPage } from '@/features/reportes/pages/venta-productos-page';
import { ReporteComprasPage } from '@/features/reportes/pages/compra-productos-page';
import { ReporteSeriesGlobalesPage } from '@/features/reportes/pages/series-globales-page';
import { AdministrativosPage } from '@/features/finanzas/pages/administrativos-page';
import { CajaChicaPage } from '@/features/finanzas/pages/caja-chica-page';
import { ControlEfectivoPage } from '@/features/finanzas/pages/control-efectivo-page';
import { CuadresPage } from '@/features/finanzas/pages/cuadres-page';
import { ContabilidadPage } from '@/features/finanzas/pages/contabilidad-page';
import { ExportarConcarPage } from '@/features/finanzas/pages/exportar-concar-page';
import { KardexPage } from '@/features/finanzas/pages/kardex-page';
import { KardexValorizadoPage } from '@/features/finanzas/pages/kardex-valorizado-page';
import { IzipayPage } from '@/features/finanzas/pages/izipay-page';
import { MovimientosPage } from '@/features/finanzas/pages/movimientos-page';
import { PagosOperadoresPage } from '@/features/finanzas/pages/pagos-operadores-page';
import { RegistrosSunatPage } from '@/features/finanzas/pages/registros-sunat-page';
import { TransferenciasPage } from '@/features/finanzas/pages/transferencias-page';
import { ReporteTurnosPage } from '@/features/reportes/pages/turnos-page';
import { ReporteVentasGnvPage } from '@/features/reportes/pages/ventas-gnv-page';
import { ReporteVentasPorMetodoPage } from '@/features/reportes/pages/ventas-por-metodo-page';
import { SubActivosPage } from '@/features/mantenimiento/pages/sub-activos-page';
import { TareasPage } from '@/features/mantenimiento/pages/tareas-page';
import { MetaDetallePage } from '@/features/metas/pages/meta-detalle-page';
import { MetaEvaluarPage } from '@/features/metas/pages/meta-evaluar-page';
import { MetaFormPage } from '@/features/metas/pages/meta-form-page';import { GruposPage } from '@/features/operaciones/pages/grupos-page';
import { TerminalesPage } from '@/features/operaciones/pages/terminales-page';
import { UsuariosPage } from '@/features/operaciones/pages/usuarios-page';
import { MetasConfiguracionPage } from '@/features/metas/pages/metas-configuracion-page';import { MetasDashboardPage } from '@/features/metas/pages/metas-dashboard-page';
import { MetasListadoPage } from '@/features/metas/pages/metas-listado-page';
import { MetasReportesPage } from '@/features/metas/pages/metas-reportes-page';
import { CategoryPage } from '@/features/modulos/pages/category-page';
import { HomePage } from '@/features/modulos/pages/home-page';
import { ConciliacionPage } from '@/features/monitoreo/pages/conciliacion-page';
import { MedicionTanquesPage } from '@/features/monitoreo/pages/medicion-tanques-page';
import { PortalMovidoPage } from '@/features/portal-movido/pages/portal-movido-page';
import { Pts2Page } from '@/features/monitoreo/pages/pts2-page';
import { SurtidorVivoPage } from '@/features/monitoreo/pages/surtidor-vivo-page';
import { TanqueVivoPage } from '@/features/monitoreo/pages/tanque-vivo-page';
import { RicMedidasPage } from '@/features/ric/pages/ric-medidas-page';
import { RicOsinermingPage } from '@/features/ric/pages/ric-osinerming-page';
import { RicVisualPage } from '@/features/ric/pages/ric-visual-page';
import { TurnosPage } from '@/features/turnos/pages/turnos-page';
import { UpdatesPage } from '@/features/updates/pages/updates-page';
import { AppShell } from '@/layouts/app-shell';

import { DefaultLandingPage } from './default-landing-page';
import { RequireAuth } from './guards';

/**
 * Rutas de la aplicación.
 *
 * Las categorías y módulos NO se declaran aquí: `/inicio` y `/inicio/:slug`
 * renderizan el catálogo que devuelve EDSuite API (ya filtrado por los permisos
 * del usuario y el plan contratado). Los módulos migrados se abren por su
 * `web_path` (ej. `/dashboard`); el resto se enlaza al panel anterior.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  /*
   * El portal del cliente **ya no vive aquí**: es una aplicación aparte
   * (`edsuite-portal`) con su propio acceso, su bundle y su proceso PM2. Esta
   * ruta sólo recoge los enlaces antiguos (`/portal-cliente/...`) y lleva al
   * cliente a la dirección nueva (`VITE_PORTAL_URL`).
   */
  {
    path: '/portal-cliente/*',
    element: <PortalMovidoPage />,
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DefaultLandingPage /> },
      { path: 'inicio', element: <HomePage /> },
      { path: 'inicio/:slug', element: <CategoryPage /> },
      { path: 'asistente', element: <AsistentePage /> },
      { path: 'dashboard', element: <DashboardPage /> },
      /* Autoservicio: layout común (filtros y navegación) y cuatro pantallas. */
      {
        path: 'autoservicio',
        element: <AutoservicioLayout />,
        children: [
          { index: true, element: <AutoservicioResumenPage /> },
          { path: 'turnos', element: <AutoservicioTurnosPage /> },
          { path: 'operaciones', element: <AutoservicioOperacionesPage /> },
          { path: 'cola', element: <AutoservicioColaPage /> },
          /* Saldos a favor: mantiene sus propios filtros y acciones (escribe en el POS). */
          { path: 'saldos', element: <SaldosAutoservicioPage /> },
        ],
      },
      { path: 'turnos-en-vivo', element: <TurnosPage /> },
      { path: 'faq', element: <FaqPage /> },
      { path: 'actualizaciones', element: <UpdatesPage /> },
      /* Metas: las rutas fijas van antes de `:id` para no capturarlas como id. */
      { path: 'metas', element: <MetasDashboardPage /> },
      { path: 'metas/listado', element: <MetasListadoPage /> },
      { path: 'metas/nueva', element: <MetaFormPage /> },
      { path: 'metas/reportes', element: <MetasReportesPage /> },
      { path: 'metas/configuracion', element: <MetasConfiguracionPage /> },
      { path: 'metas/:id', element: <MetaDetallePage /> },
      { path: 'metas/:id/editar', element: <MetaFormPage /> },
      { path: 'metas/:id/evaluar', element: <MetaEvaluarPage /> },
      /* Monitoreo y Control: rutas fijas antes de cualquier `:id`. */
      { path: 'monitoreo/surtidor', element: <SurtidorVivoPage /> },
      { path: 'monitoreo/tanques', element: <TanqueVivoPage /> },
      { path: 'monitoreo/conciliacion', element: <ConciliacionPage /> },
      { path: 'monitoreo/medicion-tanques', element: <MedicionTanquesPage /> },
      { path: 'monitoreo/calibracion', element: <CalibracionCodigosPage /> },
      { path: 'monitoreo/calibracion/reporte', element: <CalibracionReportePage /> },
      { path: 'monitoreo/calibracion/reporte/detalles', element: <CalibracionDetallesPage /> },
      { path: 'monitoreo/ric', element: <RicMedidasPage /> },
      { path: 'monitoreo/ric/visual', element: <RicVisualPage /> },
      { path: 'monitoreo/ric/osinerming', element: <RicOsinermingPage /> },
      { path: 'monitoreo/pts2', element: <Pts2Page /> },
      /* Configuración: hub, logs, operadores, planes y módulos. */
      { path: 'configuracion', element: <ConfiguracionPage /> },
      { path: 'configuracion/empresa', element: <EmpresaPage /> },
      { path: 'configuracion/bancos', element: <BancosPage /> },
      { path: 'configuracion/cuentas-bancarias', element: <CuentasBancariasPage /> },
      { path: 'configuracion/tarjetas', element: <TarjetasPage /> },
      { path: 'configuracion/monedas', element: <MonedasPage /> },
      { path: 'configuracion/tipos-documento', element: <TiposDocumentoPage /> },
      { path: 'configuracion/series-documento', element: <SeriesDocumentoPage /> },
      { path: 'configuracion/metodos-pago', element: <MetodosPagoPage /> },
      { path: 'configuracion/metodos-pago-detraccion', element: <MetodosPagoDetraccionPage /> },
      { path: 'configuracion/tipos-detraccion', element: <TiposDetraccionPage /> },
      { path: 'configuracion/turnos', element: <TurnosCatalogoPage /> },
      { path: 'configuracion/nfc', element: <NfcPage /> },
      { path: 'configuracion/pagos-cpe', element: <PagosCpePage /> },
      { path: 'configuracion/logs', element: <LogsPage /> },
      { path: 'configuracion/operadores', element: <OperadoresPage /> },
      { path: 'configuracion/planes', element: <PlanesPage /> },
      { path: 'configuracion/modulos', element: <ModulosPage /> },
      { path: 'configuracion/maquinas', element: <MaquinasPage /> },
      { path: 'configuracion/lados', element: <LadosPage /> },
      { path: 'configuracion/mangueras', element: <ManguerasPage /> },
      { path: 'configuracion/ric-automation', element: <RicAutomationPage /> },
      { path: 'configuracion/servicios', element: <ServiciosPage /> },
      { path: 'configuracion/servicios/documentos', element: <ComprobantesServiciosPage /> },

      /*
       * Turno del operador: mi turno, sus documentos, notas de venta y vales.
       *
       * Las tres pantallas de trabajo (`/turno`, el cierre y el punto de venta) van
       * detrás de `SoloOperadorTurno`: el administrador no abre ni opera turnos, y sin
       * esa puerta podía abrir uno a su nombre desde la barra de direcciones (el módulo
       * no está en su catálogo, pero la ruta sí respondía).
       */
      {
        path: 'turno',
        element: (
          <SoloOperadorTurno titulo="Mi turno">
            <TurnoPage />
          </SoloOperadorTurno>
        ),
      },
      {
        path: 'turno/cerrar',
        element: (
          <SoloOperadorTurno titulo="Cerrar turno">
            <TurnoCerrarPage />
          </SoloOperadorTurno>
        ),
      },
      {
        path: 'turno/comprobante',
        element: (
          <SoloOperadorTurno titulo="Crear comprobante">
            <TurnoComprobantePage />
          </SoloOperadorTurno>
        ),
      },
      { path: 'turno/documentos', element: <TurnoDocumentosPage /> },
      { path: 'turno/notas', element: <TurnoNotasPage /> },
      { path: 'turno/creditos', element: <TurnoCreditosPage /> },

      /* Bonus (fidelización): historial de transacciones, balance, acumulación y canje. */
      { path: 'bonus/transacciones', element: <BonusTransaccionesPage /> },
      { path: 'bonus/balance', element: <BonusBalancePage /> },
      { path: 'bonus/acumular', element: <BonusAcumularPage /> },
      { path: 'bonus/canje', element: <BonusCanjePage /> },
      
      /* Operaciones: grupos, usuarios y terminales POS. */
      { path: 'operaciones/grupos', element: <GruposPage /> },
      { path: 'operaciones/terminales', element: <TerminalesPage /> },
      { path: 'operaciones/usuarios', element: <UsuariosPage /> },
      
      /* Mantenimiento: categorías, activos, sub-activos, tareas, dashboard y reportes. */
      { path: 'mantenimiento/categorias', element: <CategoriasPage /> },
      { path: 'mantenimiento/activos', element: <ActivosPage /> },
      { path: 'mantenimiento/sub-activos', element: <SubActivosPage /> },
      { path: 'mantenimiento/tareas', element: <TareasPage /> },
      { path: 'mantenimiento/reportes', element: <ReportesMantenimientoPage /> },

      /* Reportes: centro de reportes, historial de cambios de precios y documentos. */
      { path: 'reportes', element: <ReportesPage /> },
      { path: 'reportes/historial-precios', element: <HistorialPreciosPage /> },
      { path: 'reportes/documentos', element: <ReporteDocumentosPage /> },
      { path: 'reportes/venta-productos', element: <ReporteVentaProductosPage /> },
      { path: 'reportes/gastos', element: <ReporteGastosPage /> },
      { path: 'reportes/ingreso-boveda', element: <ReporteIngresoBovedaPage /> },
      { path: 'reportes/ventas-cliente', element: <ReporteVentasDescuentosPage /> },
      { path: 'reportes/bitacora-izipay', element: <ReporteBitacoraIzipayPage /> },
      { path: 'reportes/placas-clientes', element: <ReportePlacasClientesPage /> },
      { path: 'reportes/consumo-interno', element: <ReporteConsumoInternoPage /> },
      { path: 'reportes/facturas-pendientes', element: <ReporteFacturasPendientesPage /> },
      { path: 'reportes/serie-fecha-producto', element: <ReporteSerieFechaProductoPage /> },
      { path: 'reportes/kardex', element: <ReporteKardexPage /> },
      { path: 'reportes/creditos-cliente', element: <ReporteCreditosClientePage /> },
      { path: 'reportes/diferencia-diaria', element: <DiferenciaDiariaPage /> },
      { path: 'reportes/faltantes-personal', element: <ReporteFaltantesPersonalPage /> },
      { path: 'reportes/descuentos-activos', element: <ReporteDescuentosActivosPage /> },
      { path: 'reportes/productividad-turnos', element: <ReporteProductividadTurnosPage /> },
      { path: 'reportes/movimientos-cuenta', element: <ReporteMovimientosCuentaPage /> },
      { path: 'reportes/nubecont', element: <ReporteNubecontPage /> },
      { path: 'reportes/compra-productos', element: <ReporteComprasPage /> },
      { path: 'reportes/series-globales-mes', element: <ReporteSeriesGlobalesPage /> },
      
      /* Finanzas y Contabilidad: movimientos de cuenta, caja chica, control de efectivo
         e ingresos y egresos administrativos. */
      { path: 'finanzas/movimientos', element: <MovimientosPage /> },
      { path: 'finanzas/caja-chica', element: <CajaChicaPage /> },
      { path: 'finanzas/control-efectivo', element: <ControlEfectivoPage /> },
      { path: 'finanzas/ingresos', element: <AdministrativosPage tipo="ingresos" /> },
      { path: 'finanzas/egresos', element: <AdministrativosPage tipo="egresos" /> },
      { path: 'finanzas/transferencias', element: <TransferenciasPage /> },
      { path: 'finanzas/pagos-operadores', element: <PagosOperadoresPage /> },
      { path: 'finanzas/izipay', element: <IzipayPage /> },
      { path: 'finanzas/cuadres', element: <CuadresPage /> },
      { path: 'finanzas/registro-compras', element: <RegistrosSunatPage registro="compras" /> },
      { path: 'finanzas/registro-ventas', element: <RegistrosSunatPage registro="ventas" /> },
      { path: 'finanzas/contabilidad', element: <ContabilidadPage /> },
      { path: 'finanzas/exportar-concar', element: <ExportarConcarPage /> },
      { path: 'finanzas/kardex', element: <KardexPage /> },
      { path: 'finanzas/kardex-valorizado', element: <KardexValorizadoPage /> },

      { path: 'reportes/turnos', element: <ReporteTurnosPage /> },
      { path: 'reportes/ventas-gnv', element: <ReporteVentasGnvPage /> },
      { path: 'reportes/ventas-por-metodo', element: <ReporteVentasPorMetodoPage /> },
      { path: 'mantenimiento', element: <MantenimientoDashboardPage /> },
      /* Logística: documentos, ventas, bóvedas y movimientos operativos. */
      { path: 'logistica/canjes-cardplus', element: <CanjesCardplusPage /> },
      { path: 'logistica/asignaciones', element: <AsignacionesPage /> },
      { path: 'logistica/documentos', element: <DocumentosPage /> },
      { path: 'logistica/notas-venta', element: <NotasVentaPage /> },
      { path: 'logistica/ventas-market', element: <VentasMarketPage /> },
      { path: 'logistica/ventas-credito', element: <VentasCreditoPage /> },
      { path: 'logistica/pagos-adelantados', element: <PagosAdelantadosPage /> },
      {
        path: 'logistica/pagos-adelantados-documentos',
        element: <PagosAdelantadosDocumentosPage />,
      },
      { path: 'logistica/bovedas', element: <BovedasPage /> },
      { path: 'logistica/gastos', element: <GastosPage /> },
      { path: 'logistica/ingresos-extras', element: <IngresosExtrasPage /> },
      { path: 'logistica/notas-credito', element: <NotasCreditoPage /> },
      /* Ruta anterior de Saldos Autoservicio: ahora vive en la categoría Autoservicio. */
      {
        path: 'logistica/saldos-autoservicio',
        element: <Navigate to="/autoservicio/saldos" replace />,
      },

      { path: 'pricing', element: <PricingDashboardPage /> },
      { path: 'pricing/precios', element: <PricingPreciosPage /> },
      { path: 'pricing/estadisticas', element: <PricingEstadisticasPage /> },
      { path: 'pricing/scraping', element: <PricingScrapingPage /> },
      { path: 'pricing/configuracion', element: <PricingConfiguracionPage /> },

      { path: 'gestion/inventario', element: <InventarioListadoPage /> },
      { path: 'gestion/inventario/entradas', element: <InventarioEntradasPage /> },
      { path: 'gestion/inventario/salidas', element: <InventarioSalidasPage /> },
      { path: 'gestion/clientes', element: <ClientesPage /> },
      { path: 'gestion/clientes/saldos', element: <ClientesSaldosPage /> },
      { path: 'gestion/clientes/mensajes', element: <MensajesClientesPage /> },
      { path: 'gestion/productos', element: <ProductosPage /> },
      {
        path: 'gestion/productos/diferencia-diaria',
        element: <Navigate to="/reportes/diferencia-diaria" replace />,
      },
      { path: 'gestion/clientes-app', element: <ClientesAppPage /> },
      { path: 'gestion/cardplus', element: <CardplusPage /> },
      { path: 'gestion/compras', element: <ComprasPage /> },
      { path: 'gestion/compras/proveedores', element: <ProveedoresPage /> },
      { path: 'gestion/fletes', element: <FletesPage /> },
      { path: 'gestion/creditos', element: <CreditosPage /> },
      { path: 'gestion/administracion', element: <AdministracionPage /> },
      { path: 'gestion/administracion/comprobantes', element: <ComprobantesPage /> },
      { path: 'gestion/administracion/comprobantes/crear', element: <ComprobanteCrearPage /> },
      { path: 'gestion/administracion/canjes-notas', element: <CanjesNotasPage /> },
      { path: 'gestion/administracion/boletaje-masivo', element: <BoletajeMasivoPage /> },
      { path: 'gestion/administracion/generador-masivo', element: <GeneradorMasivoPage /> },
      { path: 'gestion/administracion/consumo', element: <ConsumoClientePage /> },
      { path: 'gestion/cotizaciones', element: <CotizacionListadoPage /> },
      { path: 'gestion/cotizaciones/nueva', element: <CotizacionFormPage /> },
      { path: 'gestion/administracion/hermes', element: <HermesPage /> },
      {
        path: '*',
        element: (
          <ErrorPage
            code="404"
            title="Página no encontrada"
            description="La dirección que abriste no existe o fue movida dentro de EDSuite Web."
          />
        ),
      },
    ],
  },
]);
